/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- COMMUNITY TOP COMMENTERS: STYLES --------------- ++++++++++ */
export default theme => ({
  topcommenters: {
    '& .sectioncontent': {
      display: 'flex',
      flexFlow: 'row wrap',
      width: '100%',
      '& .control': {
        minWidth: pxToEm(64),
        maxWidth: pxToEm(64),
        flex: 1,
        flexBasis: '20%',
        marginBottom: pxToEm(8),
        marginRight: pxToEm(8)
      }
    }
  }
});
